<script setup>
import {NFlex, NImage} from "naive-ui";

// eslint-disable-next-line no-undef
defineProps(['image', 'title', 'text'])
</script>

<template>
  <n-flex class="flex" vertical>
    <n-image :src="image" width="100%" :preview-disabled="true"/>
    <div class="title">{{ title }}</div>
    <div class="text">{{ text }}</div>
  </n-flex>
</template>

<style scoped>
.flex {
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.flex:hover {
  transform: translateY(-5px);
  box-shadow: var(--glass-shadow);
  border-color: rgba(99, 226, 183, 0.3);
}

.title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-top: 12px;
  color: var(--text-color);
}

.text {
  text-align: center;
  padding: 0 16px 24px;
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
}
</style>